export const HomeSiteInitialQuestion =[
    "Pricing",
    "Request Demo",
    "Features",
    "Contact Us"
  ]


  export const SQLAgentInitialQuestion =[
    "How many returns are marked as paid?",
    "How many returns are transmitted?",
    "Show returns where compensation not exceeds 5000",
    "Total filings in tax year 2022"
  ]
  
  export const TBSInitialQuestion =[]